<template>
  <div id="chat">
    <div v-if="loadingChat" class="pull-right meetbeans_sidebar messages">
      <!-- skeleton chat -->
      <skeleton-box width="60px" height="60px" style="border-radius: 30px" />
      <skeleton-box />
      <skeleton-box />

      <skeleton-box
        width="60px"
        height="60px"
        style="border-radius: 30px;float: right;margin-top: 25px"
      />
      <skeleton-box />
      <skeleton-box />
    </div>
    <div
      class="pull-right meetbeans_sidebar messages"
      id="chatWindow"
      v-if="messages.length > 0 && !loadingChat"
    >
      <div v-for="(m, i) in messages" :key="i" :id="'chat' + i">
        <div v-if="m.uid != user.uid" class="pull-left">
          <div class="chatting">
            <img :src="m.image" />
            <div>
              <span style="position: relative;right: 5px;bottom: 8px;">
                {{ m.account_name }}
                <span
                  id="user-info"
                  class="text-secondary"
                  style="position: absolute;left: 0px;bottom: -15px;font-size: 8.5px;width: 200px"
                  >{{ m.designation }}, {{ m.company }}</span
                >
              </span>
              <div style="margin-left: 30px;position: relative ">
                <p
                  class="message-text"
                  v-linkified:options="{ className: 'text-link' }"
                >
                  {{ m.message }}
                  <span
                    id="message-date"
                    class="text-muted"
                    style="position: absolute;right: 8px;bottom: 5px;font-size: 10px;"
                    >{{
                      $moment
                        .utc(m.created_at)
                        .local()
                        .format("LT")
                    }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="float-right">
          <div id="products">
            <div class="message-blue" style="position: relative">
              <p
                class="message-content"
                v-linkified:options="{ className: 'text-link' }"
                style="border-radius: 8px"
              >
                {{ m.message }}
                <span
                  id="message-date"
                  class="text-muted"
                  style="position: absolute;right: 8px;bottom: 5px;font-size: 10px;"
                  >{{
                    $moment
                      .utc(m.created_at)
                      .local()
                      .format("LT")
                  }}</span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="messages text-center"
      v-else-if="messages.length == 0 && !loadingChat"
      style="height: 70vh;"
    >
      <div
        style="position: absolute;top: 50%;left: 50%;margin-right: -50%;transform: translate(-50%, -50%)"
      >
        <svg
          width="60"
          height="60"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <image
            href="../assets/no-message.svg"
            style="color: #fbaf28 !important;"
            width="60"
            height="60"
          />
        </svg>
        <br />
        <span>
          <b>Type your message</b>
        </span>
        <p>It’s time to start the chat</p>
      </div>
    </div>
    <div id="pickerView" style="width: 100%;height: 25px;"></div>

    <div class="sendbox">
      <div class="form-group pt-2">
        <div style="display: flex;">
          <button
            id="emojiPickerBtn"
            @click="toggleEmojiPicker"
            style="background: #000;border: 1px solid #6c757c;border-right: 0;border-top-left-radius: 8px;border-bottom-left-radius: 8px;width: 50px"
          >
            <i class="far fa-smile" style="color: #6c757c;font-size: 22px"></i>
          </button>
          <input
            id="chatInput"
            style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;"
            type="text"
            class="form-control"
            autocomplete="off"
            v-model="channelMessage"
            v-on:keyup.enter="handleChannelMessage"
            placeholder="Chat with anyone..."
            aria-label="channelmessage"
          />

          <button
            @click="handleChannelMessage"
            class="btn btn-primary"
            type="button"
            id="general-send-button"
            style="margin-left: -4px; border-radius: 0 5px 5px 0"
            v-if="channelMessage !== ''"
          >
            <svg
              width="20"
              height="20"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <image href="../assets/send.svg" width="20" height="20" />
            </svg>
          </button>
          <button
            class="btn btn-primary"
            type="button"
            id="general-send-button-disable"
            style="margin-left: -4px; border-radius: 0 5px 5px 0"
            v-else
          >
            <svg
              width="20"
              height="20"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <image href="../assets/send.svg" width="20" height="20" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonBox from "./SkeletonBox.vue";
import AgoraRTM from "agora-rtm-sdk";
import EmojiButton from "@joeattardi/emoji-button";

// const picker = new EmojiButton({
//   emojiSize: "1.4em",
//   position: "auto-start",
//   style: "twemoji",
//   theme: "auto",
//   zIndex: "100000",
// });

const picker = new EmojiButton({
  showPreview: false,
  emojiSize: "1.4em",
  position: "auto",
  style: "bottom",
  theme: "auto",
  rootElement: document.getElementById("pickerView"),
});

export default {
  components: {
    SkeletonBox,
  },
  data() {
    return {
      appId: "1188c95f362547c98469c3c67f487f60",
      uid: "",
      user: {},
      client: "",
      handRaiseUserID: "",
      channel: "",
      channelId: "test",
      rtmToken: null,
      accountName: "",
      channels: {},
      isLoggedIn: false,
      channelMessage: "",
      messages: [],
      name1: [],
      name2: [],
      flagContainer: {
        isReactionAnimation: false,
      },
      channelMemberCount: Number,
      memberInterval: "",
      loadingChat: true,
      intervalId: null,
    };
  },
  beforeCreate() {},
  beforeDestroy() {
    clearInterval(this.memberInterval);
    this.$root.$emit("pleaseHandleDeclineByHost", this.uid);
    this.client.logout();
  },
  created() {
    // init AgoraRTC local client
    if (this.$route.params.id) {
      // this.accountName = this.uid
      this.user = JSON.parse(localStorage.getItem("user_info"));
      this.accountName = this.user.name;
      // this.accountName = this.uid
      if (this.user !== "undefined" || this.user !== {}) {
        this.getAgoraRTMTokenFunction();
      } else {
        this.$toast.open({
          message: "No user found, Please try login again !",
          type: "error",
          position: "top",
          queue: true
        });
      }
    } else {
      this.$toast.open({
        message: "Sorry meeting id is required.",
        type: "success",
        position: "top",
        queue: true
      });
    }
  },
  // beforeUpdate() {
  //   const $ = this;
  //   $.$root.$on("handleEventReaction", () => {
  //     console.log('%c:Got Reation from user--', 'background: #ff00dd; color: #00ff00', );
  //   });
  // },
  mounted() {
    const $ = this;
    $.$root.$on("scrollDown", () => {
      this.scrollDown();
    });
    picker.on("emoji", (emoji) => {
      this.channelMessage += emoji;
    });
    $.$root.$on("exit", () => {
      // this.$store.state.isLive = false;
      // this.$store.state.streamCount = 0;
      $.client.logout();
    });
    $.$root.$on("removeVideoLayoutChange", (data) => {
      $.sendChannelMessage({
        type: "removeVideoLayoutChangeMessage",
        data: data,
      });
    });
     $.$root.$on("unstableConnection", () => {
      let user_info = JSON.parse(localStorage.getItem("user_info"));
      $.sendChannelMessage({
        type: "unstableConnection",
        data: user_info.name
      });
    });
    $.$root.$on("shareVideoStarted", (data) => {
      $.sendChannelMessage({
        type: "shareVideoStartedMessage",
        data: data,
      });
    });
    $.$root.$on("emojiCounter", (data) => {
      $.sendChannelMessage({
        type: "emojiCounterMessage",
        data: data,
      });
    });
    $.$root.$on("shareVideo", (data) => {
      $.sendChannelMessage({
        type: "shareVideoMessage",
        data: data,
      });
    });
    $.$root.$on("removeShareVideo", (data) => {
      $.sendChannelMessage({
        type: "removeShareVideoMessage",
        data: data,
      });
    });
    $.$root.$on("setSpeaker", (arr) => {
      // $.$store.isSpeaker = true;
      $.sendChannelMessage({
        type: "setSpeakerMessage",
        data: arr,
      });
    });
    $.$root.$on("notifySessionEnd", () => {
      $.sendChannelMessage({
        type: "notifySessionEndMessage",
      });
    });
    $.$root.$on("showPollToUsers", (data) => {
      // console.log("ShowPollToUsers called");

      $.sendChannelMessage({
        type: "showPollToUsersMessage",
        data: data,
      });
    });
    $.$root.$on("updateVotes", (obj) => {
      $.sendChannelMessage({
        type: "updateVotesMessage",
        data: obj,
      });
    });
    $.$root.$on("clientScreenShareStarted", (screenUid) => {
      $.sendChannelMessage({
        type: "clientScreenShareStarted",
        data: screenUid,
      });
    });
    $.$root.$on("stopScreenShareByHost", (uid) => {
      $.sendChannelMessage({
        type: "stopScreenShareByHost",
        data: uid,
      });
    });
    $.$root.$on("clientHostHasStoppedTimer", () => {
      $.sendChannelMessage({
        type: "clientHostHasStoppedTimer",
      });
    });
    $.$root.$on("clientScreenShareStopped", () => {
      $.sendChannelMessage({
        type: "clientScreenShareStopped",
      });
    });
    $.$root.$on("clientScreenShareStartedForTable", (screenUid) => {
      $.sendChannelMessage({
        type: "clientScreenShareStartedForTable",
        data: screenUid,
      });
    });
    $.$root.$on("clientScreenShareStoppedForTable", () => {
      $.sendChannelMessage({
        type: "clientScreenShareStoppedForTable",
      });
    });
    // $.$root.$on("clientScreenShareStartedForTable", () => {
    //   $.sendChannelMessage({
    //     type: "clientScreenShareStartedForTable"
    //   });
    // });
    // $.$root.$on("clientScreenShareStoppedForTable", () => {
    //   $.sendChannelMessage({
    //     type: "clientScreenShareStoppedForTable",
    //   });
    // });
    $.$root.$on("takeFeedback", () => {
      $.sendChannelMessage({
        type: "takeFeedback",
      });
    });
    $.$root.$on("clientIncreaseYourStreamCount", () => {
      $.sendChannelMessage({
        type: "clientIncreaseYourStreamCount",
      });
    });
    $.$root.$on("screenShareLoaderStartForTable", (tableId) => {
      $.sendChannelMessage({
        type: "screenShareLoaderStartForTable",
        data: tableId,
      });
    });
    $.$root.$on("screenShareLoaderStart", () => {
      $.sendChannelMessage({
        type: "screenShareLoaderStarted",
      });
    });
    $.$root.$on("screenShareLoaderStop", () => {
      $.sendChannelMessage({
        type: "screenShareLoaderStopped",
      });
    });
    $.$root.$on("screenShareLoaderStopForTable", (tableId) => {
      $.sendChannelMessage({
        type: "screenShareLoaderStopForTable",
        data: tableId,
      });
    });
    $.$root.$on("handleWithdraw", () => {
      // console.log(
      //   "%c:Got msg for withdrwa sending to client--",
      //   "background: #ff00dd; color: #00ff00"
      // );
      $.sendChannelMessage({
        type: "handleWithdraw",
      });
    });
    $.$root.$on("deleteMeFromYourRecord", (obj) => {
      $.sendChannelMessage({
        type: "deleteMeFromYourRecord",
        data: obj,
      });
    });
    $.$root.$on("notifyUserOnBreak", () => {
      $.sendChannelMessage({
        type: "notifyUserOnBreak",
      });
    });

    $.$root.$on("hostLeftTheMeet", () => {
      $.sendChannelMessage({
        type: "hostLeftTheMeet",
      });
    });

    $.$root.$on("updateRecordOnLeave", (obj) => {
      $.sendChannelMessage({
        type: "updateRecordOnLeave",
        data: obj,
      });
    });
    $.$root.$on("seatSelected", (obj) => {
      $.sendChannelMessage({
        type: "seatSelected",
        data: obj,
      });
    });
    $.$root.$on("clientStartTheSession", () => {
      $.sendChannelMessage({
        type: "clientStartTheSession",
      });
    });
    $.$root.$on("pleaseemptylocalstream", () => {
      $.sendChannelMessage({
        type: "pleaseemptylocalstream",
      });
    });
    $.$root.$on("pleaseDeleteLocalStream", (uid) => {
      $.sendChannelMessage({
        type: "pleaseDeleteLocalStream",
        data: uid,
      });
    });
    $.$root.$on("playUserStream", (uid) => {
      $.sendChannelMessage({
        type: "playuserstream",
        data: uid,
      });
    });
    $.$root.$on("hideHost", () => {
      $.sendChannelMessage({
        type: "hideHost",
        data: {id: $.uid, isHidden: true},
      });
    });
    $.$root.$on("unhideHost", () => {
      $.sendChannelMessage({
        type: "unhideHost"
      });
    });
    $.$root.$on("pleaseHandleDeclineByHost", (uid) => {
      $.sendChannelMessage({
        type: "handDecline",
        data: uid,
      });
    });
    $.$root.$on("handleHandRaise", (deviceInfo) => {
      $.sendChannelMessage({
        //Bug is here
        type: "handRaise",
        data: deviceInfo,
      });
    });
    $.$root.$on("handleReaction", (emojiId) => {
      // console.log(emojiId);
      $.sendChannelMessage({
        type: "reaction",
        id: emojiId,
      });
    });
    // $.$root.$on("getAudience", () => {
    //   $.getMeetingMembers()
    // });
  },
  updated() {
    this.scrollDown();
  },
  methods: {
    getMeetingMembers() {
      const $ = this;
      $.client
        .getChannelMemberCount([$.channelId])
        .then((channelList) => {
          $.channelMemberCount = channelList.Discussion;
          if (
            $.channelMemberCount !== null &&
            $.channelMemberCount !== undefined
          ) {
            $.$root.$emit("receiveChannelMemberCount", $.channelMemberCount);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      $.channel
        .getMembers()
        .then((channelMember) => {
          $.channelMembers = channelMember;
          if ($.channelMembers !== null && $.channelMembers !== undefined) {
            $.$root.$emit("receiveChannelMembers", $.channelMembers);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // clearInterval(this.memberInterval);
      // // To get data realtime
      // this.memberInterval = setInterval(function() {
      //   $.channel.getMembers().then((channelMember) => {
      //     $.channelMembers = channelMember;
      //     if ($.channelMembers !== null && $.channelMembers !== undefined) {
      //       $.$root.$emit("receiveChannelMembers", $.channelMembers);
      //       $.$store.state.attendeeCount = $.channelMembers.length;
      //     }
      //   });
      //   // .catch(() => {
      //   //   window.location.reload()
      //   // });
      // }, 10000);
    },
    getUserData(id) {
      const $ = this;
      let da = {
        channel_id: $.$route.params.id,
      };
      $.$store.dispatch("getMembersData", da).then((resp) => {
        if (resp.data.status === "success") {
          $.$store.state.members = resp.data.data;
          resp.data.data.forEach((member) => {
            if (member.uid == id) {
              return member;
            }
          });
        }
      });
    },
    scrollDown: function() {
      var container = document.querySelector("#chatWindow");
      // var chatBox = document.querySelector('.chatting');
      // console.log("HEIGHT:", chatBox.clientHeight);
      // console.log("Container: ", container);
      //
      // console.log("ScrollHeight: ", container.scrollHeight);

      container.scrollTop = container.scrollHeight;

      // document.querySelector('.chatting').scrollIntoView(false);
    },
    getAgoraRTMTokenFunction: function() {
      const $ = this;
      // console.log("%c:uid", "background: #222; color: #00ff00", $.uid);
      if ($.uid !== null) {
        let data = {
          channel_id: this.$route.params.id,
          uid: $.user.uid,
        };
        this.$store.dispatch("getAgoraRTMToken", data).then((resp) => {
          if (resp.data.status === "success") {
            $.rtmToken = resp.data.data.rtm_token;
            $.uid = resp.data.data.uid;
            $.channelId = resp.data.data.channel_name;
            // console.log("cid: ", $.channelId);
            this.handleClient();
          } else {
            this.$toast.open({
              message: resp.data.data,
              type: "error",
              position: "top",
              queue: true
            });
          }
        });
      }
    },

    handleInstance(appId) {
      this.client = AgoraRTM.createInstance(appId);
      this.subscribeClientEvents();
    },

    subscribeClientEvents() {
      const $ = this;

      $.client.on("ConnectionStateChanged", (newState, reason) => {
        // console.log("reason", reason, "newState: ", newState);
        if (newState === "ABORTED") {
          if (reason === "REMOTE_LOGIN") {
            // alert("It seems you are already active in other device. Please logout, to resume session refresh 😅.");
            // $.client.logout()
            // console.log("channel name: ", $.channelId);
            clearInterval($.memberInterval);
            $.$root.$emit("handleLeaveTable_1", this.user.uid);
            this.$router.push("/");
            console.log("REMOTE_LOGIN reason", reason, "newState: ", newState);
          }
        }
      });
      // event ends here
      $.client.on("MessageFromPeer", (message, peerId) => {
        let data = {
          message: message.text,
          uid: peerId,
          account_name: peerId,
          date: new Date(),
          image: $.user.photoURL,
        };
        $.messages.push(data);
        $.scrollDown();
      });
      // event ends here
    },

    subscribeChannelEvents() {
      let $ = this;

      $.channel.on("ChannelMessage", (args, senderId) => {
        const text = args.text;

        if (
          text !== "heart" &&
          text !== "clap" &&
          text !== "thumb" &&
          text !== "laugh" &&
          text !== "handraise_1" &&
          text !== "playuserstream_1" &&
          text !== "hideHost_1" &&
          text !== "unhideHost_1" &&
          text !== "handdecline_1" &&
          text !== "pleaseDeleteLocalStream_1" &&
          text !== "pleaseemptylocalstream_1" &&
          text !== "clientStartTheSession_1" &&
          text !== "seatSelected_1" &&
          text !== "clientScreenShareStarted_1" &&
          text !== "stopScreenShareByHost_1" &&
          text !== "clientIncreaseYourStreamCount_1" &&
          text !== "screenShareLoaderStarted_1" &&
          text !== "unstableConnection_1" &&
          text !== "screenShareLoaderStartedForTable_1" &&
          text !== "screenShareLoaderStopped_1" &&
          text !== "screenShareLoaderStoppedForTable_1" &&
          text !== "clientScreenShareStartedForTable_1" &&
          text !== "clientScreenShareStoppedForTable_1" &&
          text !== "clientScreenShareStopped_1" &&
          text !== "clientHostHasStoppedTimer_1" &&
          text !== "hostLeftTheMeet_1" &&
          text !== "emojiCounter_1" &&
          text !== "showPollToUsers_1" &&
          text !== "updateVotesMessage_1" &&
          text !== "notifySessionEndMessage_1" &&
          text !== "takeFeedback_1" &&
          text !== "shareVideo_1" &&
          text !== "removeShareVideo_1" &&
          text !== "removeVideoLayoutChangeMessage_1" &&
          text !== "shareVideoStarted_1"
        ) {
          let message_data = JSON.parse(text);
          if ("message" in message_data) {
            if (message_data.message === "handdecline_1") {
              $.$root.$emit(
                "deletethisuserfromhandrequestarray",
                message_data.data
              );
            } else if (message_data.message === "handraise_1") {
              $.$root.$emit(
                "sendingBackIdForHandraise",
                senderId,
                message_data.data
              );
            } else if (message_data.message === "handleWithdraw_1") {
              $.$root.$emit("withdrawRequest", senderId);
            } else if (message_data.message === "removeShareVideo_1") {
              $.$root.$emit("removeShareVideoClient");
            } else if (message_data.message === "shareVideo_1") {
              $.$root.$emit("shareVideoClient");
            } else if (
              message_data.message === "removeVideoLayoutChangeMessage_1"
            ) {
              $.$root.$emit("removeVideoLayoutChange_1", message_data.data);
            } else if (message_data.message === "shareVideoStarted_1") {
              $.$root.$emit("shareVideoStartedClient", message_data.data);
            } else if (message_data.message === "emojiCounter_1") {
              $.$root.$emit("emojiCountIncrease", message_data.data);
            } else if (message_data.message === "notifySessionEndMessage_1") {
              $.$root.$emit("notifySessionEnd_1", message_data.data);
            } else if (message_data.message === "updateVotesMessage_1") {
              $.$root.$emit("updateVotes_1", message_data.data);
            } else if (message_data.message === "showPollToUsers_1") {
              $.$root.$emit("showPollToClients", message_data.data);
            } else if (message_data.message === "takeFeedback_1") {
              $.$root.$emit("takeFeedbackFromUser", message_data.data);
            } else if (message_data.message === "playuserstream_1") {
              $.$root.$emit("playvideoforuser", message_data.data);
            } else if (message_data.message === "hideHost_1") {
              $.$root.$emit("hostIsHidden", message_data.data);
            } else if (message_data.message === "unhideHost_1") {
              $.$root.$emit("hostIsUnhidden");
            } else if (message_data.message === "setSpeaker_1") {
              if (message_data.data.length > 0) {
                message_data.data.forEach((x) => {
                  if (x.email === $.user.email) {
                    $.$root.$emit("clientSetSpeaker");
                  } else {
                    $.$store.state.isSpeaker = false;
                    $.$store.state.isStage = false;
                  }
                });
              }
            } else if (message_data.message === "pleaseDeleteLocalStream_1") {
              $.$root.$emit("pleaseDeleteYourLocalStream", message_data.data);
            } else {
              $.$root.$emit("newMessageNotifier");
              // console.log("nms: ", JSON.parse(text));
              if (this.$store.state.newMessagesCount === 1) {
                let newMessageHeader = `<h6 style='	margin: 25px 0px 25px;font-size: 10px;font-weight: bold;width: 306px;text-align: center;border-bottom: 1px solid #fff;line-height: 0;'>
                <span style='background: #fff;color: black;padding: 5px 30px;border-radius: 3px;'>
                New Messages
                </span>
                </h6>`;
                if (document.getElementById("chatWindow")) {
                  let msgheader = document.createElement("div");
                  msgheader.setAttribute("id", "chatNewMsg");
                  msgheader.innerHTML = newMessageHeader;
                  document.getElementById("chatWindow").appendChild(msgheader);
                }
              }
              $.messages.push(JSON.parse(text));
              let msg = JSON.parse(text);
              if (!document.hasFocus()) {
                // console.log("focused !", !document.hasFocus());
                this.$notification.show(
                  `New Message By ${msg.account_name}`,
                  {
                    body: `${msg.message}`,
                    icon: `https://meetbeans-data.s3.ap-south-1.amazonaws.com/logo-512x512.png`
                  },
                  {}
                );
              } else {
                console.log("focus else", !document.hasFocus());
              }
              $.scrollDown();
            }
          } else {
            //  for table communication
            if (message_data.text === "seatSelected_1") {
              const $ = this;
              const data = JSON.parse(args.text);
              const tableId = data.data.tableId;
              const chairId = data.data.chairId;
              // console.log("Seat Selected " + tableId + " with " + chairId)
              $.$store.state.members.forEach((member) => {
                if (member.uid == senderId) {
                  $.$store.state.tables.forEach((table) => {
                    if (table.table_id === tableId) {
                      switch (chairId) {
                        case 1:
                          table.chair_1 = member;
                          break;
                        case 2:
                          table.chair_2 = member;
                          break;
                        case 3:
                          table.chair_3 = member;
                          break;
                        case 4:
                          table.chair_4 = member;
                          break;
                        default:
                          break;
                      }
                    }
                  });
                }
              });
              // console.log("members:", $.$store.state.members)
              // console.log("tables:", $.$store.state.tables)
              $.$root.$emit("getTableData");
              // setTimeout(function() {
              //   let da = {
              //     channel_id: $.$route.params.id,
              //   };
              //   $.$store.dispatch("getMembersData", da).then((resp) => {
              //     if (resp.data.status === "success") {
              //       $.$store.state.members = resp.data.data;
              //     }
              //   });
              // }, 500);
            } else if (
              message_data.text === "screenShareLoaderStartedForTable_1"
            ) {
              $.$root.$emit(
                "screenShareLoaderStartedForTable",
                message_data.data
              );
            }  else if (message_data.text === "unstableConnection_1") {
              $.$root.$emit("unstableConnectionNotify", message_data.data);
            } else if (
              message_data.text === "screenShareLoaderStoppedForTable_1"
            ) {
              $.$root.$emit(
                "screenShareLoaderStoppedForTable",
                message_data.data
              );
            } else if (message_data.text === "updateRecordOnLeave_1") {
              const data = JSON.parse(args.text);
              const tableId = data.data.tableId;
              const chairId = data.data.chairId;
              $.$store.state.tables.forEach((table) => {
                if (table.table_id == tableId) {
                  switch (chairId) {
                    case 1:
                      table.chair_1 = "";
                      break;
                    case 2:
                      table.chair_2 = "";
                      break;
                    case 3:
                      table.chair_3 = "";
                      break;
                    case 4:
                      table.chair_4 = "";
                      break;
                    default:
                      break;
                  }
                }
              });
            } else if (message_data.text === "deleteMeFromYourRecord_1") {
              const data = JSON.parse(args.text);
              const { tableId, chairId } = data.data;
              $.$store.state.tables.forEach((table) => {
                if (table.table_id === tableId) {
                  table[`chair_${chairId}`] = "";
                }
              });
            } else if (message_data.text === "clientScreenShareStarted_1") {
              const data = JSON.parse(args.text);
              $.$root.$emit("clientScreenShareHasStarted", data.data);
            } else if (message_data.text === "stopScreenShareByHost_1") {
              const data = JSON.parse(args.text);
              $.$root.$emit("stopScreenShare", data.data);
            } else if (
              message_data.text === "clientScreenShareStartedForTable_1"
            ) {
              const data = JSON.parse(args.text);
              $.$root.$emit("clientScreenShareHasStartedForTable", data.data);
            } else if (message_data.text === "notifyUserOnBreak_1") {
              $.$root.$emit("clientBreakIsOn");
            } else if (message_data.text === "clientStartTheSession_1") {
              // $.$root.$emit("speakerLoaderScreenStart");
              const data = JSON.parse(args.text);
              $.intervalId = data.intervalId;
              if (data.data === "stop") {
                clearInterval(this.intervalId);
                // $.$root.$emit("speakerLoaderScreenStop");
                return;
              }
              if (data.data === 1) {
                $.$root.$emit("unpublishSpeakers");
                // $.$root.$emit("speakerLoaderScreenStop");
                $.$store.state.isLive = true;
              }
              $.$toast.open({
                message: "Start session in " + data.data + " sec",
                type: "info",
                position: "bottom-left",
                duration: 500,
                queue: true
              });
            }
          }
        } else if (text === "hideHost_1") {
          $.$root.$emit("hostIsHidden", senderId);
        } else if (text === "unhideHost_1") {
          $.$root.$emit("hostIsUnhidden");
        } else if (text === "heart") {
          $.$root.$emit("showReaction", "heart");
        } else if (text === "clap") {
          $.$root.$emit("showReaction", "clap");
        } else if (text === "thumb") {
          $.$root.$emit("showReaction", "thumb");
        } else if (text === "laugh") {
          $.$root.$emit("showReaction", "laugh");
        }
        // else if (text === "handraise_1") {
        //   // $.flagContainer.isReactionAnimation = true;
        //   const uid = senderId;
        //   $.$root.$emit("sendingBackIdForHandraise", uid);
        // }
        //  else if (text === "handdecline_1") {
        //   // $.flagContainer.isReactionAnimation = true;
        //   const uid = senderId;
        //   $.$root.$emit("deletethisuserfromhandrequestarray", uid);
        // }
        else if (text === "pleaseemptylocalstream_1") {
          $.$root.$emit("clientpleaseemptylocalstream");
        }
        //  else if (text === "clientScreenShareStarted_1") {
        //   $.$root.$emit("clientScreenShareHasStarted", senderId);
        // }
        //  else if (text === "clientScreenShareStartedForTable_1") {
        //   $.$root.$emit("clientScreenShareHasStartedForTable", senderId);
        // }
        else if (text === "clientScreenShareStoppedForTable_1") {
          $.$root.$emit("clientScreenShareHadStoppedForTable", senderId);
          // $.$root.$emit("clientScreenShareHasStarted", senderId);
        } else if (text === "clientScreenShareStopped_1") {
          $.$root.$emit("clientScreenShareHasStopped", senderId);
        } else if (text === "clientIncreaseYourStreamCount_1") {
          $.$root.$emit("clientPleaseIncreaseYourStreamCount");
        } else if (text === "screenShareLoaderStarted_1") {
          $.$root.$emit("screenShareLoaderStarted");
        } else if (text === "screenShareLoaderStopped_1") {
          $.$root.$emit("screenShareLoaderStopped");
        } else if (text === "clientHostHasStoppedTimer_1") {
          // const $ = this;
          alert($.intervalId);
          clearInterval($.intervalId);
          // you can use this emiter as per application need
          // $.$root.$emit("clientHostHadStoppedTimer");
        } else if (text === "hostLeftTheMeet_1") {
          $.$toast.open({
            message: "Host Left The Meet",
            type: "info",
            position: "top",
            queue: true
          });
        }
        // text: text of the received channel message; senderId: user ID of the sender.
        /* Your code for handling events, such as receiving a channel message. */
      });

      $.channel.on("MemberJoined", (args, senderId) => {
        console.log("channel ", $.channelId, " member: ", senderId, " joined");
        $.getMeetingMembers(senderId);
      });

      $.channel.on("MemberLeft", (senderId) => {
        console.log("channel ", $.channelName, " member: ", senderId, " left");
        $.getMeetingMembers(senderId);
        $.$root.$emit("handleLeaveTable_1", senderId);
        $.$root.$emit("deletethisuserfromhandrequestarray", senderId);
      });
    },

    handleChannelLeave() {
      let $ = this;
      $.channel.leave();
    },

    handleChannelJoin() {
      let $ = this;
      const newChannel = $.client.createChannel($.channelId);
      $.channel = newChannel;
      $.channels[$.channelId] = {
        newChannel,
        joined: false, // channel state
      };
      $.channel
        .join()
        .then(() => {
          /* Your code for handling the event of a join-channel success. */
          $.subscribeChannelEvents();
          $.getMeetingMembers();
        })
        .catch((error) => {
          /* Your code for handling the event of a join-channel failure. */
          console.error(error);
        });
    },

    handleLogin() {
      const $ = this;
      $.client
        .login({ uid: $.uid, token: null })
        .then(() => {
          $.$store.state.isChatConnect = true;
          $.isLoggedIn = true;
          $.handleChannelJoin();
          $.getMessageFunction();
          $.$root.$emit("getAudience");
        })
        .catch((err) => {
          console.error("RTM client login failure ", err);
        });
    },

    handleClient() {
      const $ = this;
      $.handleInstance($.appId);
      $.handleLogin();
    },
    storeMessageFunction(text) {
      const $ = this;
      let data = {
        channel_id: $.$route.params.id,
        text: text,
      };
      if (text !== "") {
        $.$store.dispatch("storeMessage", data).then((resp) => {
          if (resp.data.status === "success") {
            $.scrollDown();
          }
        });
      }
    },
    getMessageFunction() {
      const $ = this;
      let data = {
        channel_id: $.$route.params.id,
      };

      $.$store.dispatch("getMessage", data).then((resp) => {
        if (resp.data.status === "success") {
          $.loadingChat = false;
          $.messages = resp.data.data;

          if ($.messages.length > 4) {
            setTimeout(function() {
              $.scrollDown();
            }, 500);
          }
        }
      });
    },

    sendChannelMessage(res) {
      const $ = this;
      if (res.type === "chat") {
        let data = {
          message: $.channelMessage,
          uid: $.uid,
          account_name: $.accountName,
          image: $.user.photoURL,
          company: $.user.company,
          designation: $.user.designation,
        };
        let text = $.channelMessage;
        $.channel
          .sendMessage({ text: JSON.stringify(data) })
          .then(() => {
            $.messages.push(data);
            $.channelMessage = "";
            // $.$root.$emit("newMessageNotifier");
            // console.log('A new message received');
            $.storeMessageFunction(text);
            if(document.querySelector("#chatNewMsg")) {
              let elm = document.querySelector("#chatNewMsg");
              elm.parentNode.removeChild(elm);
            }
            $.scrollDown();
          })
          .catch((error) => {
            /* Your code for handling events, such as a channel message-send failure. */
            console.log("Send Message", error);
          });
      } else if (res.type === "shareVideoStartedMessage") {
        const data = {
          message: "shareVideoStarted_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.log(err);
        });
      } else if (res.type === "removeShareVideoMessage") {
        const data = {
          message: "removeShareVideo_1",
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.log(err);
        });
      } else if (res.type === "shareVideoMessage") {
        const data = {
          message: "shareVideo_1",
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.log(err);
        });
      }  else if (res.type === "takeFeedback") {
        const data = {
          message: "takeFeedback_1",
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.log(err);
        });
      } else if (res.type === "removeVideoLayoutChangeMessage") {
        const data = {
          message: "removeVideoLayoutChangeMessage_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.log(err);
        });
      } else if (res.type === "emojiCounterMessage") {
        const data = {
          message: "emojiCounter_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.log(err);
        });
      } else if (res.type === "setSpeakerMessage") {
        const data = {
          message: "setSpeaker_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.log(err);
        });
      } else if (res.type === "notifySessionEndMessage") {
        const data = {
          message: "notifySessionEndMessage_1",
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.log(err);
        });
      } else if (res.type === "updateVotesMessage") {
        const data = {
          message: "updateVotesMessage_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.log(err);
        });
      } else if (res.type === "showPollToUsersMessage") {
        const data = {
          message: "showPollToUsers_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.log(err);
        });
      } else if (res.type === "reaction") {
        // $.flagContainer.isReactionAnimation = true;
        // $.$root.$emit("showReaction", res.emojiId);
        // setTimeout(function() {
        //   $.flagContainer.isReactionAnimation = false;
        //   $.$root.$emit("hideReaction");
        // }, 2000);
        $.channel
          .sendMessage({ text: res.id })
          .then(() => {
            // $.$root.$emit("unhideHost", $.uid);
            console.log("res.id: ", res.id);
          })
          .catch((error) => {
            console.error("sendMessage", error);
          });
      } else if (res.type === "handRaise") {
        const data = {
          message: "handraise_1",
          data: res.data,
        };
        $.channel
          .sendMessage({
            text: JSON.stringify(data),
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "startSession") {
        $.channel
          .sendMessage({ text: "startSession" }, { rawMessage: "startSession" })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "handDecline") {
        const data = {
          message: "handdecline_1",
          data: res.data,
        };
        $.channel
          .sendMessage({
            text: JSON.stringify(data),
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "playuserstream") {
        const data = {
          message: "playuserstream_1",
          data: res.data,
        };
        $.channel
          .sendMessage({
            text: JSON.stringify(data),
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "hideHost") {
        const data = {
          message: "hideHost_1",
          data: res.data,
        };

        $.channel
          .sendMessage({
            text: JSON.stringify(data),
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "unhideHost") {
        const data = {
          message: "unhideHost_1",
          data: res.data,
        };
        $.channel
          .sendMessage({
            text: JSON.stringify(data),
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "pleaseDeleteLocalStream") {
        const data = {
          message: "pleaseDeleteLocalStream_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.error(err);
        });
      } else if (res.type === "pleaseemptylocalstream") {
        $.channel
          .sendMessage({ text: "pleaseemptylocalstream_1" })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "clientStartTheSession") {
        const $ = this;
        let timer = 10;
        if (res.data === "stop") {
          clearInterval(this.intervalId);
          return;
        }
        // $.$root.$emit("speakerLoaderScreenStart");
        this.intervalId = setInterval(function() {
          if (timer === 0) {
            // $.$root.$emit("speakerLoaderScreenStop");
            $.$store.state.isLive = true;
            clearInterval($.intervalId);
          } else {
            const data = {
              text: "clientStartTheSession_1",
              data: timer,
              intervalId: $.intervalId,
            };
            $.channel
              .sendMessage({
                text: JSON.stringify(data),
              })
              .catch((err) => {
                console.error(err);
              });
            timer = timer - 1;
          }
        }, 1000);
      } else if (res.type === "seatSelected") {
        const data = {
          text: "seatSelected_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.error(err);
        });
      } else if (res.type === "updateRecordOnLeave") {
        const data = {
          text: "updateRecordOnLeave_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.error(err);
        });
      } else if (res.type === "deleteMeFromYourRecord") {
        const data = {
          text: "deleteMeFromYourRecord_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.error(err);
        });
      } else if (res.type === "notifyUserOnBreak") {
        const data = {
          text: "notifyUserOnBreak_1",
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.error(err);
        });
      } else if (res.type === "hostLeftTheMeet") {
        const data = {
          text: "hostLeftTheMeet_1",
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.error(err);
        });
      } else if (res.type === "handleWithdraw") {
        const data = {
          message: "handleWithdraw_1",
        };
        $.channel
          .sendMessage({
            text: JSON.stringify(data),
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "clientScreenShareStarted") {
        let data = {
          text: "clientScreenShareStarted_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.error(err);
        });
      } else if (res.type === "stopScreenShareByHost") {
        let data = {
          text: "stopScreenShareByHost_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.error(err);
        });
      } else if (res.type === "clientScreenShareStopped") {
        $.channel
          .sendMessage({
            text: "clientScreenShareStopped_1",
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "clientScreenShareStartedForTable") {
        const data = {
          text: "clientScreenShareStartedForTable_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.error(err);
        });
      } else if (res.type === "clientScreenShareStoppedForTable") {
        $.channel
          .sendMessage({
            text: "clientScreenShareStoppedForTable_1",
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "clientIncreaseYourStreamCount") {
        $.channel
          .sendMessage({
            text: "clientScreenShareStartedForTable_1",
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "screenShareLoaderStarted") {
        $.channel
          .sendMessage({
            text: "screenShareLoaderStarted_1",
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "screenShareLoaderStopped") {
        $.channel
          .sendMessage({
            text: "screenShareLoaderStopped_1",
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "screenShareLoaderStartForTable") {
        let data = {
          text: "screenShareLoaderStartedForTable_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.error(err);
        });
      }  else if (res.type === "unstableConnection") {
        let data = {
          text: "unstableConnection_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.error(err);
        });
      } else if (res.type === "screenShareLoaderStopForTable") {
        let data = {
          text: "screenShareLoaderStoppedForTable_1",
          data: res.data,
        };
        $.channel.sendMessage({ text: JSON.stringify(data) }).catch((err) => {
          console.error(err);
        });
      } else if (res.type === "clientScreenShareStoppedForTable") {
        $.channel
          .sendMessage({
            text: "clientScreenShareStoppedForTable_1",
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "clientIncreaseYourStreamCount") {
        $.channel
          .sendMessage({
            text: "clientIncreaseYourStreamCount_1",
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (res.type === "clientHostHasStoppedTimer") {
        $.sendChannelMessage({
          type: "clientStartTheSession",
          data: "stop",
        });
      }
    },
    toggleEmojiPicker(e) {
      picker.togglePicker(e);
      let p = document.getElementsByClassName("emoji-picker")[0];
      p.style.position = "absolute";
      p.style.width = "325px";
      p.style.right = "112px";
      p.style.bottom = "17.5%";
    },
    handleChannelMessage(e) {
      const $ = this;
      if (e) {
        e.preventDefault();
      }
      if (!$.isLoggedIn) {
        // Toast.error('Please Login First')
        alert(
          "Please refresh the page in order to subscribe in the chat. Thanks 😅"
        );
        return;
      }
      if ($.channelMessage.trim() === "") {
        return;
      }

      $.sendChannelMessage({
        type: "chat",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
html {
  scroll-behavior: smooth;
}

.meetbeans_sidebar {
  box-sizing: border-box;
  height: 70vh;
  overflow-y: auto;
  width: 100%;
  /*@media only screen and (max-width: 1100px) {*/
  /*	height: 75vh;*/
  /*}*/
}

#products {
  padding: 10px;

  .message-blue {
    margin-bottom: 4px;
    padding: 10px;
    background-color: #613e00;
    width: 288px;
    height: auto;
    text-align: left;
    font: 400 0.9em "Open Sans", sans-serif;
    border-radius: 8px;

    .message-content {
      padding: 0;
      margin: 0;
      color: #fff;
    }
  }
}

.channel-padding {
  // position: relative;
  left: 731px;
  top: 250px;

  label {
    font-weight: bold;
    font-size: 25px;
    display: block;
    margin-bottom: 2px;
  }

  input {
    background: #1b1b1b !important;
    color: #fff !important;
    padding: 7px;
    margin-bottom: 11px;
    display: block;
  }
}

.meetbeans_chatBox ul .active_chat {
  border-bottom: 2px solid #fbaf28;
  padding-bottom: 5px;
  width: 45%;
  text-align: center;
}

.meetbeans_chatBox ul .active_chat a {
  color: #fbaf28;
  font-size: 25px;
}

.meetbeans_chatBox ul .deactive_chat {
  width: 45%;
  text-align: center;
}

.meetbeans_chatBox ul .deactive_chat a {
  font-size: 25px;
  color: #ccc;
}

.div_user {
  padding-bottom: 25px;
  margin-top: 25px;
}

.chatting {
  width: 270px;
}

.chatting img {
  float: left;
  max-width: 30px;
  width: 100%;
  margin-right: 10px;
  border-radius: 50%;
}

.chatting div span {
  font-size: 12px;
  color: #ccc;
  position: relative;
  right: 5px;
  bottom: -2px;
}

.chatting div p {
  background-color: #1b1b1b;
  padding: 10px;
  border-radius: 8px;
  color: #fff;
  margin-top: 6px;
  height: auto;
  font-size: 14px;
}

.chatter_herself div {
  position: relative;
  top: 52px;
  left: 17px;
  background-color: #fbaf28;
  color: #000;
  padding: 20px 0px 20px 0px;
  text-align: center;
  margin-right: 16px;
  border-radius: 10px;
  height: auto;
}
.sendbox {
  position: absolute;
  bottom: 0px;
  width: 96%;
}
</style>
